<template>
  <div class="">
    <section class="title">
      <div class="header__text-box">
        <h1 class="heading-primary">
          <span class="heading-primary--main">Projects </span>
        </h1>
      </div>
    </section>
    <Crumbs />
    //TODO: LINK UP THE PROJECTS ON THE FRONT PAGE TO THE BLOGS
    <section class="section-admin">
      <div class="card full">
        <multiselect
          v-model="value"
          :multiple="true"
          :options="options"
          :taggable="true"
          tag-placeholder="Add this as new tag"
          @tag="addTag"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Crumbs from "@/components/layout/Crumbs";
import Multiselect from 'vue-multiselect'
import {
  getFirebaseCollection,
  updateFirebaseDocument,
  deleteFirebaseDocument
} from "@/functions/firebase/base";
export default {
  name: "ProjectAdmin",
  components: {
    Crumbs,
    Multiselect
  },
  data() {
    return {
        value: null,
         options: ['list', 'of', 'options']
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
